var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54169 18.4998C1.54169 18.4998 7.70835 6.1665 18.5 6.1665C29.2917 6.1665 35.4584 18.4998 35.4584 18.4998C35.4584 18.4998 29.2917 30.8332 18.5 30.8332C7.70835 30.8332 1.54169 18.4998 1.54169 18.4998Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.1248C21.0543 23.1248 23.125 21.0542 23.125 18.4998C23.125 15.9455 21.0543 13.8748 18.5 13.8748C15.9457 13.8748 13.875 15.9455 13.875 18.4998C13.875 21.0542 15.9457 23.1248 18.5 23.1248Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_1694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.50833aae5f8e6b70be1549922b2b5e4a.svg";
export { ForwardRef as ReactComponent };